import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Stack,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { DataGrid } from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { IconButton } from "@mui/material";
import eSimServices from "../../services/EsimService";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import * as XLSX from "xlsx";
const EsimActivationPage = () => {
  const [file, setFile] = useState(null);

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [showFilters, setShowFilters] =
    useState(false);
  const [filters, setFilters] = useState({
    activation_type: "",
    card_status: "",
    card_state: "",
    esim_status: "",
    kyc_status: "",
    activation_date_from: "",
    activation_date_to: "",
    created_at_from: "",
    created_at_to: "",
  });
  const [toast, setToast] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const fetchEsimData = async (searchValue = "",
    filterValues = filters) => {
    try {
      setLoading(true);

      const response = await eSimServices.getEsimList({
        page: 1,
        page_size: 50,
        search: searchValue,
        filters: filterValues,
      });

      setRows(response?.data?.results || []);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const timer = setTimeout(() => {
      fetchEsimData(search, filters);
    }, 500);

    return () => clearTimeout(timer);
  }, [search, filters]);

  useEffect(() => {
    fetchEsimData("");
  }, []);

  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState({});

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) return;

    try {
      const formData = new FormData();
      formData.append("excel_file", file);

      const response =
        await eSimServices.uploadEsimExcel(
          formData
        );

      let message =
        response?.data?.message || "";

      if (
        response?.data?.errors?.length
      ) {
        const errorMessages =
          response.data.errors
            .map(
              (err) =>
                `Row ${err.row}: ${err.error}`
            )
            .join("\n");

        message = `${message}\n\n${errorMessages}`;

        setToast({
          open: true,
          severity: "warning",
          message,
        });
      } else {
        setToast({
          open: true,
          severity: "success",
          message,
        });
      }

      fetchEsimData();

      setFile(null);
    } catch (error) {
      setToast({
        open: true,
        severity: "error",
        message:
          error?.response?.data?.error ||
          "Upload Failed",
      });
    }
  };

  const handleEdit = (row) => {
    setEditData(row);
    setOpen(true);
  };

  const handleSave = async () => {
    try {
      const payload = {
        id: editData.id,

        imei: editData.imei,

        card_status: editData.card_status,
        card_state: editData.card_state,

        primary_status: editData.primary_status,
        fallback_status: editData.fallback_status,

        esim_status: editData.esim_status,

        activation_date: editData.activation_date,
        expiry_date: editData.expiry_date,

        kyc_status: editData.kyc_status,
        kyc_remarks: editData.kyc_remarks,

        remarks: editData.remarks,

        whitelisted_ip: editData.whitelisted_ip,
        whitelisted_mobile_no:
          editData.whitelisted_mobile_no,
        whitelisted_apn:
          editData.whitelisted_apn,
      };

      const response =
        await eSimServices.updateEsim(
          payload
        );

      setToast({
        open: true,
        severity: "success",
        message:
          response?.data?.imei
            ? `eSIM ${response.data.imei} updated successfully`
            : "eSIM updated successfully",
      });

      setOpen(false);

      fetchEsimData(search, filters);
    } catch (error) {
      const data =
        error?.response?.data;

      let errorMessage =
        "Update Failed";

      if (
        data &&
        typeof data === "object"
      ) {
        errorMessage = Object.entries(
          data
        )
          .map(
            ([field, msgs]) =>
              `${field}: ${Array.isArray(msgs)
                ? msgs.join(", ")
                : msgs
              }`
          )
          .join("\n");
      }

      setToast({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  };

  const handleDownloadSample = () => {
    const link = document.createElement("a");

    link.href = "/templates/sample/esim_sample.xlsx";

    link.download = "esim_sample.xlsx";

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };
  const formatDateTime = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  });
};

const handleDownloadExcel = () => {
  if (!rows.length) {
    setToast({
      open: true,
      severity: "warning",
      message: "No data available to download.",
    });
    return;
  }

  const exportData = rows.map((item) => ({
    IMEI: item.imei,
    "Device Model": item.device_model,
    "Primary ICCID": item.iccid_primary,
    "Secondary ICCID": item.iccid_secondary,
    "Primary Provider": item.telecom_provider_primary,
    "Secondary Provider": item.telecom_provider_secondary,
    "Primary MSISDN": item.msisdn_primary,
    "Secondary MSISDN": item.msisdn_secondary,
    "Primary IMSI": item.imsi_primary,
    "Secondary IMSI": item.imsi_secondary,
    "Activation Type": item.activation_type,
    "eSIM Status": item.esim_status,
    "eSIM Validity": item.esim_validity,
    "Activation Date": item.activation_date,
    "Expiry Date": item.expiry_date,
    "Card Status": item.card_status,
    "Card State": item.card_state,
    "Primary Status": item.primary_status,
    "Fallback Status": item.fallback_status,
    "KYC Status": item.kyc_status,
    "Last KYC Date": item.last_kyc_date,
    "KYC Remarks": item.kyc_remarks,
    Remarks: item.remarks,
    "Whitelisted IP": item.whitelisted_ip,
    "Whitelisted Mobile": item.whitelisted_mobile_no,
    "Whitelisted APN": item.whitelisted_apn,
    "Created By": item.created_by_name,
    "Updated By": item.updated_by_name,
    "Created At": item.created_at,
    "Updated At": item.updated_at,
  }));

  const worksheet = XLSX.utils.json_to_sheet(exportData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "eSIM Report"
  );

  const reportType =
  filters.activation_type === "1_year"
    ? "1_Year"
    : filters.activation_type === "2_year"
    ? "2_Year"
    : "All";

XLSX.writeFile(
  workbook,
  `eSIM_Activation_Report_${reportType}_${new Date()
    .toISOString()
    .slice(0, 10)}.xlsx`
);
};

const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
  const columns = [
    { field: "imei", headerName: "IMEI", minWidth: 180 },
    { field: "device_model", headerName: "Device Model", minWidth: 150 },

    { field: "iccid_primary", headerName: "Primary ICCID", minWidth: 220 },
    { field: "iccid_secondary", headerName: "Secondary ICCID", minWidth: 220 },

    {
      field: "telecom_provider_primary",
      headerName: "Primary Provider",
      minWidth: 150,
    },
    {
      field: "telecom_provider_secondary",
      headerName: "Secondary Provider",
      minWidth: 150,
    },

    { field: "msisdn_primary", headerName: "Primary MSISDN", minWidth: 150 },
    { field: "msisdn_secondary", headerName: "Secondary MSISDN", minWidth: 150 },

    { field: "imsi_primary", headerName: "Primary IMSI", minWidth: 180 },
    { field: "imsi_secondary", headerName: "Secondary IMSI", minWidth: 180 },

    { field: "activation_type", headerName: "Activation Type", minWidth: 130 },

    { field: "esim_status", headerName: "eSIM Status", minWidth: 130 },

    { field: "esim_validity", headerName: "eSIM Validity", minWidth: 130 },

    {
  field: "activation_date",
  headerName: "Activation Date",
  minWidth: 130,
  renderCell: ({ value }) => formatDate(value),
},

    {
      field: "expiry_date",
      headerName: "Expiry Date",
      minWidth: 130,
      renderCell: ({ value }) => formatDate(value)},

    {
      field: "card_status",
      headerName: "Card Status",
      minWidth: 130,
    },

    {
      field: "card_state",
      headerName: "Card State",
      minWidth: 130,
    },

    {
      field: "primary_status",
      headerName: "Primary Status",
      minWidth: 130,
    },

    {
      field: "fallback_status",
      headerName: "Fallback Status",
      minWidth: 130,
    },

    {
      field: "kyc_status",
      headerName: "KYC Status",
      minWidth: 130,
    },

    {
      field: "last_kyc_date",
      headerName: "Last KYC Date",
      minWidth: 130,
        renderCell: ({ value }) => formatDate(value),

    },

    {
      field: "kyc_remarks",
      headerName: "KYC Remarks",
      minWidth: 200,
    },

    {
      field: "remarks",
      headerName: "Remarks",
      minWidth: 200,
    },

    {
      field: "whitelisted_ip",
      headerName: "Whitelisted IP",
      minWidth: 180,
    },

    {
      field: "whitelisted_mobile_no",
      headerName: "Whitelisted Mobile",
      minWidth: 180,
    },

    {
      field: "whitelisted_apn",
      headerName: "Whitelisted APN",
      minWidth: 180,
    },

    {
      field: "created_by_name",
      headerName: "Created By",
      minWidth: 120,
    },

    {
      field: "updated_by_name",
      headerName: "Updated By",
      minWidth: 120,
    },

    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 180,
        renderCell: ({ value }) => formatDate(value),

    },

    {
      field: "updated_at",
      headerName: "Updated At",
      minWidth: 180,
        renderCell: ({ value }) => formatDate(value),

    },

    {
      field: "action",
      headerName: "Action",
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <IconButton
          color="primary"
          onClick={() => handleEdit(params.row)}
        >
          <EditIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Box p={3}>
      <Typography
        variant="h4"
        fontWeight={600}
        mb={3}
      >
        ESIM Activation Requests
      </Typography>

      {/* Upload Section */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Typography
          variant="h6"
          gutterBottom
        >
          Upload ESIM Activation Excel
        </Typography>

        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          flexWrap="wrap"
        >
          <Button
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
          >
            Select File
            <input
              hidden
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
            />
          </Button>

          <Typography>
            {file?.name || "No file selected"}
          </Typography>

          <Button
            variant="contained"
            disabled={!file}
            onClick={handleUpload}
          >
            Upload
          </Button>
          <Button
            variant="outlined"
            onClick={handleDownloadSample}
          >
            Download Sample
          </Button>
        </Stack>
      </Paper>

      {/* Table Section */}
      <Paper sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 2 }}>
          <Box
            display="flex"
            alignItems="center"
            gap={2}
          >
            <TextField
              size="small"
              placeholder="Search IMEI, ICCID, Provider, MSISDN, IMSI, Device Model..."
              value={search}
              onChange={(e) =>
                setSearch(e.target.value)
              }
            />

            <Button
              variant={
                showFilters
                  ? "contained"
                  : "outlined"
              }
              startIcon={<FilterListIcon />}
              onClick={() =>
                setShowFilters(
                  !showFilters
                )
              }
            >
              Filters
            </Button>
            <Button
  variant="contained"
  color="success"
  onClick={handleDownloadExcel}
>
  Download Excel
</Button>
          </Box>
          {showFilters && (
            <>
              <Stack
                direction="row"
                spacing={2}
                mt={2}
                flexWrap="wrap"
                useFlexGap
              >
                {/* Activation Type */}
                <Stack
                  direction="row"
                  spacing={2}
                  mt={2}
                  flexWrap="wrap"
                  useFlexGap
                >
                  <TextField
                    select
                    size="small"
                    label="Activation Type"
                    value={filters.activation_type}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        activation_type: e.target.value,
                      })
                    }
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="bootstrap">Bootstrap</MenuItem>
                    <MenuItem value="1_year">1 Year</MenuItem>
                    <MenuItem value="2_year">2 Year</MenuItem>
                  </TextField>

                  <TextField
                    select
                    size="small"
                    label="Card Status"
                    value={filters.card_status}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        card_status: e.target.value,
                      })
                    }
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="Suspend">Suspend</MenuItem>
                    <MenuItem value="Expired">Expired</MenuItem>
                  </TextField>

                  <TextField
                    select
                    size="small"
                    label="eSIM Status"
                    value={filters.esim_status}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        esim_status: e.target.value,
                      })
                    }
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Active">Active</MenuItem>
                    <MenuItem value="Inactive">Inactive</MenuItem>
                    <MenuItem value="Expired">Expired</MenuItem>
                    <MenuItem value="Suspend">Suspend</MenuItem>
                  </TextField>

                  <TextField
                    select
                    size="small"
                    label="KYC Status"
                    value={filters.kyc_status}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        kyc_status: e.target.value,
                      })
                    }
                    sx={{ minWidth: 180 }}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="Pending">Pending</MenuItem>
                    <MenuItem value="Verified">Verified</MenuItem>
                    <MenuItem value="Rejected">Rejected</MenuItem>
                  </TextField>
                </Stack>

              </Stack>

              <Stack
                direction="row"
                spacing={2}
                mt={2}
                flexWrap="wrap"
                useFlexGap
              >
                <Stack
                  direction="row"
                  spacing={2}
                  mt={2}
                  flexWrap="wrap"
                  useFlexGap
                >
                  <TextField
                    label="Activation From"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filters.activation_date_from}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        activation_date_from: e.target.value,
                      })
                    }
                  />

                  <TextField
                    label="Activation To"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filters.activation_date_to}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        activation_date_to: e.target.value,
                      })
                    }
                  />

                  <TextField
                    label="Created From"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={filters.created_at_from}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        created_at_from: `${e.target.value}T00:00:00Z`,
                      })
                    }
                  />

                  <TextField
                    label="Created To"
                    type="date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={
                      filters.created_at_to?.split("T")[0] || ""
                    }
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        created_at_to: `${e.target.value}T23:59:59Z`,
                      })
                    }
                  />

                  <Button
                    variant="outlined"
                    color="error"
                    onClick={() => {
                      setFilters({
                        activation_type: "",
                        card_status: "",
                        card_state: "",
                        esim_status: "",
                        kyc_status: "",
                        activation_date_from: "",
                        activation_date_to: "",
                        created_at_from: "",
                        created_at_to: "",
                      });
                    }}
                  >
                    Clear Filters
                  </Button>
                </Stack>
              </Stack>
            </>
          )}


        </Paper>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h6">
            eSIM Records ({rows.length})
          </Typography>
        </Box>
        <DataGrid
          rows={rows}
          columns={columns}
          loading={loading}
          autoHeight
          disableRowSelectionOnClick
          disableColumnFilter
          disableColumnMenu
          disableColumnSelector
          disableDensitySelector
          getRowId={(row) => row.id}
          pageSizeOptions={[10, 25, 50, 100]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
        />
      </Paper>

      {/* Edit Dialog */}
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          Update ESIM Request
        </DialogTitle>

        <DialogContent>
          <Stack spacing={2} mt={2}>
            <TextField
              label="IMEI"
              value={editData.imei || ""}
              disabled
              fullWidth
            />

            <TextField
              select
              label="Card Status"
              value={editData.card_status || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  card_status: e.target.value,
                })
              }
              fullWidth
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
              <MenuItem value="Suspend">Suspend</MenuItem>
              <MenuItem value="Expired">Expired</MenuItem>
            </TextField>
            <TextField
              select
              label="eSIM Status"
              value={editData.esim_status || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  esim_status: e.target.value,
                })
              }
            >
              <MenuItem value="Inactive">
                Inactive
              </MenuItem>
              <MenuItem value="Active">
                Active
              </MenuItem>
              <MenuItem value="Expired">
                Expired
              </MenuItem>
              <MenuItem value="Suspend">
                Suspend
              </MenuItem>
              <MenuItem value="Limited Connectivity">
                Limited Connectivity
              </MenuItem>
            </TextField>
            <TextField
              select
              label="KYC Status"
              value={editData.kyc_status || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  kyc_status: e.target.value,
                })
              }
              fullWidth
            >
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Verified">Verified</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </TextField>

            <TextField
              select
              label="Card State"
              value={editData.card_state || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  card_state: e.target.value,
                })
              }
            >
              <MenuItem value="Provisioned">
                Provisioned
              </MenuItem>
              <MenuItem value="Allocated">
                Allocated
              </MenuItem>
              <MenuItem value="Bootstrap">
                Bootstrap
              </MenuItem>
              <MenuItem value="Commercial">
                Commercial
              </MenuItem>
              <MenuItem value="Terminated">
                Terminated
              </MenuItem>
            </TextField>

            <TextField
              label="Remarks"
              multiline
              rows={3}
              value={editData.remarks || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  remarks: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              select
              label="Primary Status"
              value={editData.primary_status || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  primary_status: e.target.value,
                })
              }
              fullWidth
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>

            <TextField
              select
              label="Fallback Status"
              value={editData.fallback_status || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  fallback_status: e.target.value,
                })
              }
              fullWidth
            >
              <MenuItem value="Active">Active</MenuItem>
              <MenuItem value="Inactive">Inactive</MenuItem>
            </TextField>

            <TextField
              label="Activation Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={editData.activation_date || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  activation_date: e.target.value,
                })
              }
              fullWidth
            />

            <TextField
              label="Expiry Date"
              type="date"
              InputLabelProps={{ shrink: true }}
              value={editData.expiry_date || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  expiry_date: e.target.value,
                })
              }
              fullWidth
            />

            <TextField
              label="KYC Remarks"
              multiline
              rows={2}
              value={editData.kyc_remarks || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  kyc_remarks: e.target.value,
                })
              }
              fullWidth
            />

            <TextField
              label="Whitelisted IP"
              value={editData.whitelisted_ip || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  whitelisted_ip: e.target.value,
                })
              }
              fullWidth
            />

            <TextField
              label="Whitelisted Mobile"
              value={
                editData.whitelisted_mobile_no || ""
              }
              onChange={(e) =>
                setEditData({
                  ...editData,
                  whitelisted_mobile_no:
                    e.target.value,
                })
              }
              fullWidth
            />

            <TextField
              label="Whitelisted APN"
              value={editData.whitelisted_apn || ""}
              onChange={(e) =>
                setEditData({
                  ...editData,
                  whitelisted_apn: e.target.value,
                })
              }
              fullWidth
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            onClick={handleSave}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={toast.open}
        autoHideDuration={6000}
        onClose={() =>
          setToast({
            ...toast,
            open: false,
          })
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          severity={toast.severity}
          variant="filled"
          onClose={() =>
            setToast({
              ...toast,
              open: false,
            })
          }
          sx={{
            whiteSpace: "pre-line",
            maxWidth: 600,
          }}
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default EsimActivationPage;